import { DataGridPro } from "@mui/x-data-grid-pro";
import * as React from "react";
import { useEffect, useState } from "react";
import { getPreviousMatches } from "../api/matches";

async function GetTeamsByEvent(body) {
  const data = await getPreviousMatches(body);
  return data;
}

export default function RobotStatsGrid({
  teams = [],
  numOfPreviousMatches = 6,
  event = "",
}) {
  const [teamData, setTeamData] = useState([]);
  console.log(teams);
  const calculateStats = (matches, property) => {
    if (matches.length === 0) return { avg: 0, max: 0 };

    const total = matches.reduce((sum, match) => sum + match[property], 0);
    const avg = Math.round((total / matches.length) * 100) / 100;
    const max = Math.max(...matches.map((match) => match[property]));

    return { avg, max };
  };

  useEffect(() => {
    if (!teams.length || !teams[0]?.team_number) return;

    const fetchMatchData = async () => {
      const flatTeams = teams.flatMap((team) => team.team_number);
      const result = await GetTeamsByEvent(
        {
          limit: Number(numOfPreviousMatches),
          teams: flatTeams,
          event: event,
        },
        event
      );
      const parsedData = JSON.parse(result?.body);
      let newTeamData = [];
      for (const [key, value] of Object.entries(parsedData.data)) {
        const matchPointsStats = calculateStats(value, "match_points");
        const autoPointsStats = calculateStats(value, "auto_points");
        const levelOneStats = calculateStats(value, "teleop_level1");
        const levelTwoStats = calculateStats(value, "teleop_level2");
        const levelThreeStats = calculateStats(value, "teleop_level3");
        const levelFourStats = calculateStats(value, "teleop_level4");
        const netScoredStats = calculateStats(value, "teleop_net_scored");
        const avgDeepSuccess =
          Math.round(
            (value.reduce(
              (sum, match) =>
                sum + (match["endgame_type"] === "succeeded_deep" ? 1 : 0),
              0
            ) /
              value.length) *
              10000
          ) / 100;
        const processorScoredStats = calculateStats(
          value,
          "teleop_processor_scored"
        );
        newTeamData.push({
          team: key,
          avgAutoPoints: autoPointsStats.avg,
          maxAutoPoints: autoPointsStats.max,
          avgMatchPoints: matchPointsStats.avg,
          maxMatchPoints: matchPointsStats.max,
          avgCoral:
            Math.round(
              (levelOneStats.avg +
                levelTwoStats.avg +
                levelThreeStats.avg +
                levelFourStats.avg) *
                100
            ) / 100,
          maxCoral:
            Math.round(
              (levelOneStats.max +
                levelTwoStats.max +
                levelThreeStats.max +
                levelFourStats.max) *
                100
            ) / 100,
          avgAlgae:
            Math.round((netScoredStats.avg + processorScoredStats.avg) * 100) /
            100,
          maxAlgae:
            Math.round((netScoredStats.max + processorScoredStats.max) * 100) /
            100,
          avgDeepSuccessRate: avgDeepSuccess,
        });
      }

      setTeamData(newTeamData);
    };

    fetchMatchData();
  }, [numOfPreviousMatches, event]);

  var columnWidth = 200;

  return (
    <>
      <DataGridPro
        rows={teamData}
        columns={[
          {
            headerName: "Team Number",
            field: "team",
            width: columnWidth,
            editable: false,
          },
          {
            headerName: "AVG Total Points",
            field: "avgMatchPoints",
            width: columnWidth,
            editable: false,
          },
          {
            headerName: "Max Total Points",
            field: "maxMatchPoints",
            width: columnWidth,
            editable: false,
          },
          {
            headerName: "AVG Auto Points",
            field: "avgAutoPoints",
            width: columnWidth,
            editable: false,
          },
          {
            headerName: "Max Auto Points",
            field: "maxAutoPoints",
            width: columnWidth,
            editable: false,
          },
          {
            headerName: "AVG Coral",
            field: "avgCoral",
            width: columnWidth,
            editable: false,
          },
          {
            headerName: "Max Coral",
            field: "maxCoral",
            width: columnWidth,
            editable: false,
          },
          {
            headerName: "AVG Algae",
            field: "avgAlgae",
            width: columnWidth,
            editable: false,
          },
          {
            headerName: "Max Algae",
            field: "maxAlgae",
            width: columnWidth,
            editable: false,
          },
          {
            headerName: "Deep Success",
            field: "avgDeepSuccessRate",
            width: columnWidth,
            editable: false,
          },
        ]}
        sx={{ display: "flex", minHeight: "125px" }}
        disableSelectionOnClick
        density="compact"
        disableVirtualization
        getRowId={(row) => row.team}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 100,
            },
          },
          pinnedColumns: { right: ["actions"] },
        }}
      />
    </>
  );
}
